import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  createFileRoute,
  useParams,
  useNavigate,
} from '@tanstack/react-router';

import { Dialog } from '@mui/material';

import { useAuthStore, useObtainTokenFromEmailToken } from '@features/auth';

const CodeView = () => {
  const looseParams = useParams({ strict: false });
  const navigate = useNavigate();

  const { mutateAsync } = useObtainTokenFromEmailToken({
    email: looseParams.email,
    authToken: looseParams.token,
  });

  useEffect(() => {
    if (looseParams.email && looseParams.token) {
      mutateAsync(
        {
          email: looseParams.email,
          authToken: looseParams.token,
        },
        {
          onSuccess: (data) => {
            useAuthStore.getState().setTokens({
              accessToken: data.access,
              refreshToken: data.refresh,
            });
            navigate({
              to: '/',
            });
          },
          onError: (error) => {
            toast.error('Invalid auth token or token has expired.');
            console.log('error', error);
          },
        }
      );
    }
  }, [looseParams.email, looseParams.token, mutateAsync]);

  return <Dialog open={true} scroll={'body'} fullWidth={true}></Dialog>;
};

export const Route = createFileRoute('/_auth/auth/token/$email/$token')({
  component: CodeView,
});
